var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-attribute-picker" }, [
    _c(
      "div",
      { staticClass: "btnGroup" },
      _vm._l(_vm.allowedContexts, function (context) {
        return _c(
          "SupsisButton",
          {
            key: context,
            attrs: {
              classNames:
                _vm.selectedContext === context
                  ? "btnGroupItem selected"
                  : "btnGroupItem ",
              primary: _vm.selectedContext === context,
              ghost: _vm.selectedContext !== context,
              small: "",
            },
            on: {
              click: function () {
                return _vm.changeSelectedContext(context)
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$_.startCase(context)) +
                "\n        "
            ),
          ]
        )
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "search-panel" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchText,
            expression: "searchText",
          },
        ],
        attrs: {
          maxlength: "128",
          placeholder: _vm.$t("chatbotv2.typeSearchValue"),
          type: "text",
        },
        domProps: { value: _vm.searchText },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchText = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter-menu" },
      [
        this.selectedMenu.length
          ? _c(
              "SupsisButton",
              { attrs: { ghost: "", small: "" }, on: { click: _vm.prev } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" chevron_left "),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(this.selectedMenu, function (menu) {
          return _c("div", { staticClass: "breadcrump-item" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.$_.get(_vm.findAttributeByValue(menu), "label")) +
                  " ✦ "
              ),
            ]),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "attribute-list" }, [
      _c(
        "div",
        { staticClass: "attr-select" },
        _vm._l(_vm.filterAttributes(), function (attr) {
          return _c(
            "div",
            {
              staticClass: "picker-item",
              class: { active: _vm.defaultSelected === attr.value },
              attrs: {
                "data-checked": "true",
                "data-index": "0",
                "data-item-label": "Name",
              },
              on: {
                click: function () {
                  return _vm.select(attr.value)
                },
              },
            },
            [
              _c("AttributeIconPreview", { attrs: { attribute: attr.value } }),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(attr.label) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      attr.placeholder == "Turkey" && attr.placeholder == "Male"
                        ? _vm.$t(
                            "chatbotv2." + attr.placeholder.toLocaleLowerCase()
                          )
                        : attr.placeholder
                    ) +
                    "\n                "
                ),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("hr"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }